import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-39553fde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = { class: "text-primary-language" }
const _hoisted_4 = { class: "text-secondary-language" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "subtitle-container" }
const _hoisted_7 = { class: "text-primary-language" }
const _hoisted_8 = { class: "text-secondary-language" }
const _hoisted_9 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('i18n.thankYouForFeedback')), 1),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.bilingual)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('i18n.thankYouForFeedback', 'en')), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('i18n.responsesSubmittedWithSuccess')), 1),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.bilingual)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t('i18n.responsesSubmittedWithSuccess', 'en')), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}